import { contentStyles } from "modules/storyblok/adapters/Content";
import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const accordionHeaderStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  paragraph: { ...contentStyles.paragraph, fontSize: "md", fontWeight: "medium" },
};

const accordionContentStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  paragraph: { ...contentStyles.paragraph, fontSize: "md" },
};

export { accordionContentStyles, accordionHeaderStyles };
